import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Success from "./components/Success";

function App() {

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="id/:id" element={<Home />} />
          <Route path=":id" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
